import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import {
    selectActiveCentionErrands,
    selectQueueIsOfTypeCentionOmni,
} from 'flow/selectors/queue-selectors';
import { fetchActiveOmniErrands } from 'flow/actions/pbx-actions';
import { CallRecordKey, QueueKey } from 'flow/types/EntityKeys';
import PbxActiveCallItem from 'flow/components/pbx/PbxActiveCallItem';

interface Props {
    queueKey: QueueKey;
}

const POLLING_INTERVAL_MS = 10_000;

const OngoingCentionErrands = ({ queueKey }: Props) => {
    const dispatch = useAppDispatch();

    const queueIsOfTypeCentionOmni = useAppSelector((state) =>
        selectQueueIsOfTypeCentionOmni(state, queueKey),
    );

    useEffect(() => {
        if (!queueIsOfTypeCentionOmni) return undefined;

        dispatch(fetchActiveOmniErrands(queueKey));
        const interval = setInterval(() => {
            dispatch(fetchActiveOmniErrands(queueKey));
        }, POLLING_INTERVAL_MS);

        return () => clearInterval(interval);
    }, [dispatch, queueKey, queueIsOfTypeCentionOmni]);

    const activeCentionErrands = useAppSelector((state) =>
        queueIsOfTypeCentionOmni
            ? selectActiveCentionErrands(state, queueKey)
            : undefined,
    );

    if (!activeCentionErrands?.size) return null;

    return (
        <>
            {activeCentionErrands
                .keySeq()
                .map((callKey: CallRecordKey) => (
                    <div key={callKey}>
                        <PbxActiveCallItem
                            callKey={callKey}
                            queueKey={queueKey}
                            isOmniErrand={true}
                        />
                    </div>
                ))
                .toArray()}
        </>
    );
};

export default OngoingCentionErrands;
